import drinksJSON from "../drinks.json";
import DrinkItem from "./components/DrinkItem";
import Boba from "../animation/boba.json";
import ToppingItem from "./components/ToppingItem";
import Lottie from "lottie-react";
import "./Drinks.css";

function Drinks() {
  return (
    <div className="flex flex-col w-full font-manrope">
      <div
        className="w-full h-screen gap-3 mx-auto overflow-hidden bg-center bg-no-repeat bg-cover flex-cl "
        style={{ backgroundImage: `url(./img/bgdrink.jpg)` }}
      >
        <div
          className="absolute top-0 bottom-0 left-0 right-0 w-full h-full overflow-hidden bg-fixed"
          style={{ backgroundColor: `rgba(0,0,0,0.3)` }}
        >
          <div className="flex items-end justify-start w-full h-full text-white flex-start">
            <h1
              id="drinks-page-title"
              className="relative w-4/6 pb-10 pl-10 pr-5 mb-10 text-6xl font-extrabold lg:w-1/2 md:pl-20 md:pr-10 md:text-9xl"
            >
              Boba Tea
            </h1>
          </div>
        </div>
      </div>

      <div className="flex flex-col w-full p-16 h-fit">
        <div className="flex flex-col w-full gap-5 mb-10 lg:mt-5 lg:pl-10 lg:pr-10 ">
          <div className="flex flex-row items-center justify-center md:gap-5">
            <img id="drink-image" src="./img/galaxy.jpg"></img>
            <div
              id="specialty"
              className="flex flex-col lg:p-5 p-2 lg:w-1/2 w-full py-5 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] border border-black border-solid rounded-lg"
            >
              <DrinkItem
                drinks={drinksJSON.drinks[0].specialty}
                title="Specialty"
              ></DrinkItem>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center md:gap-5">
            <div
              id="tea&slush"
              className="flex flex-col lg:p-5 p-2 py-5 lg:shadow-[-8px_8px_0px_0px_rgba(0,0,0,1)] shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] border border-black border-solid lg:w-1/2 w-full rounded-lg"
            >
              <DrinkItem
                drinks={drinksJSON.drinks[1]["tea&slush"]}
                title="Tea & Slush"
              ></DrinkItem>
            </div>
            <img id="drink-image" src="./img/tea.jpg"></img>
          </div>
          <div className="flex flex-row items-center justify-center md:gap-5">
            <img id="drink-image" src="./img/milktea.jpg"></img>
            <div
              id="milktea"
              className="flex flex-col lg:w-1/2 w-full lg:p-5 p-2 py-5 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] border border-black border-solid rounded-lg"
            >
              <DrinkItem
                drinks={drinksJSON.drinks[2].milktea}
                title="Milk Tea"
              ></DrinkItem>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center md:gap-5">
            <div
              id="frap"
              className="flex flex-col lg:w-1/2 w-full lg:shadow-[-8px_8px_0px_0px_rgba(0,0,0,1)] shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] border border-black border-solid lg:p-5 p-2 py-5 rounded-lg"
            >
              <DrinkItem
                drinks={drinksJSON.drinks[3]["frap&snow"]}
                title="Frap & Snow"
              ></DrinkItem>
            </div>
            <img id="drink-image" src="./img/frap.jpg"></img>
          </div>

          <div className="flex flex-row items-center justify-center md:gap-5">
            <img id="drink-image" src="./img/smth.webp"></img>
            <div
              id="smoothies"
              className="flex flex-col lg:w-1/2 w-full shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] border border-black border-solid lg:p-5 p-2 py-5 rounded-lg"
            >
              <DrinkItem
                drinks={drinksJSON.drinks[4].smoothies}
                title="Smoothies"
              ></DrinkItem>
            </div>
          </div>

          <hr class="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700"></hr>
          <div className="flex flex-col items-center justify-center">
            <h1
              id="title"
              className="mb-5 text-xl font-extrabold text-center uppercase w-fit md:text-4xl"
            >
              Add-ons
            </h1>
            <div className="flex flex-col w-full gap-5 md:flex-row justify-items-stretch">
              <div
                id="teapioca&jelly"
                className="flex flex-col w-full p-2 py-5 border-2 border-black border-solid rounded-lg shadow-lg lg:w-1/2 lg:p-5 bg-lime-50"
              >
                <ToppingItem
                  drinks={drinksJSON.drinks[5]["teapioca&jelly"]}
                  title="Teapioca & Jelly"
                ></ToppingItem>
              </div>

              <div
                id="poppings"
                className="flex flex-col w-full p-2 py-5 border-2 border-black border-solid rounded-lg shadow-lg lg:w-1/2 lg:p-5 bg-red-50"
              >
                <ToppingItem
                  drinks={drinksJSON.drinks[6].poppings}
                  title="Popping Pearls"
                ></ToppingItem>
              </div>

              <div
                id="others"
                className="flex flex-col lg:w-1/2 w-full lg:p-5 p-2 py-[30px] shadow-lg rounded-lg border-2 border-black border-solid bg-teal-50"
              >
                <ToppingItem
                  drinks={drinksJSON.drinks[7].othertoppings}
                  title="Other Toppings"
                ></ToppingItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Drinks;
